import { useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { useContext, useEffect, useState, useRef, useCallback, Fragment } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import "./PhotoPostAi.css";
import AiContentAudit from "../../Components/AiContentAudit/AiContentAudit";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentPhotoPostAi from "../Gallery/ContentPhotoPostAi";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";

const backgroundColorOptions = [
  { value: "deep-navy-blue", label: "Deep Navy Blue" },
  { value: "rich-indigo", label: "Rich Indigo" },
  { value: "dark-forest-green", label: "Dark Forest Green" },
  { value: "dark-maroon-burgundy", label: "Dark Maroon / Burgundy" },
  { value: "deep-teal", label: "Deep Teal" },
  { value: "dark-espresso-brown", label: "Dark Espresso Brown" },
  { value: "true-charcoal-black", label: "True Charcoal Black" },
  { value: "indigo-violet", label: "Indigo-Violet" },
  { value: "darker-imperial-purple", label: "Darker Imperial Purple" },
  { value: "deep-olive-drab", label: "Deep Olive Drab" },
  { value: "midnight-arctic-blue", label: "Midnight Arctic Blue" },
  { value: "very-dark-aubergine", label: "Very Dark Aubergine" },
  { value: "dark-hunter-green", label: "Dark Hunter Green" },
  { value: "dark-crimson", label: "Dark Crimson" },
];

const specificTextColors = [
  { value: "white", label: "White" },
  { value: "vibrant-gold", label: "Vibrant Gold" },
  { value: "gold", label: "Gold" },
  { value: "soft-mint", label: "Soft Mint" },
  { value: "bright-amber", label: "Bright Amber" },
  { value: "azure-mist", label: "Azure Mist" },
  { value: "creamed-honey", label: "Creamed Honey" },
  { value: "medium-gray", label: "Medium Gray" },
  { value: "lavender-mist", label: "Lavender Mist" },
  { value: "amber", label: "Amber" },
  { value: "wheat", label: "Wheat" },
  { value: "light-blue", label: "Light Blue" },
  { value: "goldenrod", label: "Goldenrod" },
  { value: "light-green", label: "Light Green" },
  { value: "lemon-chiffon", label: "Lemon Chiffon" },
];

const textColorOptions = [
  { value: "random", label: "Random" },
  ...specificTextColors,
];

const getRandomBackgroundColor = () => {
  const randomIndex = Math.floor(Math.random() * backgroundColorOptions.length);
  return backgroundColorOptions[randomIndex].value;
};

const getRandomTextColor = (excludeColor = null) => {
  const availableColors = specificTextColors.filter(option => option.value !== excludeColor);
  if (availableColors.length === 0) return specificTextColors[0].value;
  const randomIndex = Math.floor(Math.random() * availableColors.length);
  return availableColors[randomIndex].value;
};

const PhotoPostAi = () => {
  const [title, setTitle] = useState("");
  const [backgroundColor, setBackgroundColor] = useState(() => getRandomBackgroundColor());

  const [textColors, setTextColors] = useState(() => {
    const t1 = getRandomTextColor();
    const t2 = getRandomTextColor(t1);
    return { textColor1: t1, textColor2: t2 };
  });

  const textColor1 = textColors.textColor1;
  const textColor2 = textColors.textColor2;

  const [customBgColor, setCustomBgColor] = useState("#000000");
  const [customTextColor1, setCustomTextColor1] = useState("#ffffff");
  const [customTextColor2, setCustomTextColor2] = useState("#ffffff");

  const setTextColor2 = (val) => {
    setTextColors((prev) => ({ ...prev, textColor2: val }));
  };

  const handleTextColor1Change = (val) => {
    setTextColors((prev) => {
      const nextT2 = (val !== "random" && val !== "custom" && prev.textColor2 === val) ? "random" : prev.textColor2;
      return { textColor1: val, textColor2: nextT2 };
    });
  };
  const [isLoading, setIsLoading] = useState(false);
  const [generatedPost, setGeneratedPost] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [jobProgress, setJobProgress] = useState(0);
  const [jobStatusText, setJobStatusText] = useState("");
  const pollingRef = useRef(null);
  const [suggestedIdea, setSuggestedIdea] = useState("");
  const [checkingPrompt, setCheckingPrompt] = useState(false);
  const promptTimeoutRef = useRef(null);

  const checkPhotoPostIdeaPrompt = async (value) => {
    if (!value?.trim()) {
      setSuggestedIdea("");
      return;
    }

    try {
      setCheckingPrompt(true);

      const authToken = localStorage.getItem("aiUser");

      const res = await axios.post(
        "https://backend.whalesai.com/api/v1/prompt-checker/check",
        {
          prompt: value,
          aiService: "photo-post-ai",
        },
        {
          headers: {
            authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (res?.data?.success) {
        setSuggestedIdea(res.data.data.suggested_prompt);
      }
    } catch (error) {
      console.log("Prompt checker error:", error);
    } finally {
      setCheckingPrompt(false);
    }
  };
  const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
  const navigate = useNavigate();
  const [attributionPage, setAttributionPage] = useState(true);
  const [auditChecked, setAuditChecked] = useState(false);
  const credit = auditChecked ? 75 + 84 : 75;
  //cost of 75 credit is 0.90 usd
  //cost of 84 credit is 1.01 usd
  const creditCostUSD = auditChecked ? 0.90 + 1.01 : 0.90;
  const [showPdfModal, setShowPdfModal] = useState(false);
  const creditToLocalString = AIuser?.credits
    ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
    : "0";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Cleanup polling on unmount
  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, []);

  const pollJobStatus = useCallback((jobId) => {
    pollingRef.current = setInterval(async () => {
      try {
        const res = await fetch(
          `https://backend.whalesai.com/api/v1/jobs/${jobId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("aiUser")}`,
            },
          }
        );
        const data = await res.json();

        if (!data.success) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsLoading(false);
          setJobProgress(0);
          setJobStatusText("");
          swal({
            text: "Failed to check job status.",
            icon: "error",
            buttons: "Ok",
            className: "modal_class_success",
          });
          return;
        }

        const job = data.job;
        setJobProgress(job.progress || 0);
        setJobStatusText(job.status || "");

        if (job.completed) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsLoading(false);
          setJobProgress(0);
          setJobStatusText("");
          setUserRefetch(!userRefetch)

          setGeneratedPost({
            zipUrl: job.result?.resultUrl,
            slides: job.result?.slides,
            summary: job.result?.summary,
          });

          // Reset form
          setTitle("");
          setSuggestedIdea("");
          const newBg = getRandomBackgroundColor();
          const newT1 = getRandomTextColor();
          const newT2 = getRandomTextColor(newT1);
          setBackgroundColor(newBg);
          setTextColors({ textColor1: newT1, textColor2: newT2 });
          setCustomBgColor("#000000");
          setCustomTextColor1("#ffffff");
          setCustomTextColor2("#ffffff");
        }

        if (job.failed) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setIsLoading(false);
          setJobProgress(0);
          setJobStatusText("");
          swal({
            text: job.error || "Generation failed. Please try again.",
            icon: "error",
            buttons: "Ok",
            className: "modal_class_success",
          });
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 3000);
  }, []);

  // const handleSubmitCredits = async () => {
  //   const deductedCredits = AIuser.credits - credit;
  //   await axios
  //     .put(
  //       "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
  //       { email: AIuser?.email, credits: deductedCredits },
  //       {
  //         headers: {
  //           authorization: `Bearer ${localStorage.getItem("aiUser")}`,
  //         },
  //       },
  //     )
  //     .then((res) => {
  //       if (res.status === 200) {
  //         setUserRefetch(!userRefetch);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleGenerate = async () => {
    if (AIuser.credits < credit) {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",
        icon: "error",
        buttons: "Buy",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
      return;
    }

    setIsLoading(true);
    setJobProgress(0);
    setJobStatusText("");
    setGeneratedPost(null);

    try {
      const body = {
        email: AIuser?.email,
        userId: AIuser?._id,
        credit,
        title,
        backgroundColor: backgroundColor === "custom" ? customBgColor : backgroundColor,
        textColor1: textColor1 === "custom" ? customTextColor1 : textColor1,
        textColor2: textColor2 === "custom" ? customTextColor2 : textColor2,
        attributionPage,
        audit: auditChecked
      };

      const response = await fetch(
        "https://backend.whalesai.com/api/v1/photo-post-ai/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("aiUser")}`,
          },
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to generate Social Post");
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.message || "Generation failed");
      }

      // Deduct credits immediately after successful job submission
      // handleSubmitCredits();
      setUserRefetch(!userRefetch)

      // Start polling for job status
      const jobId = data.jobId;
      setJobStatusText(data.message || "Processing...");
      pollJobStatus(jobId);

    } catch (error) {
      console.error("Error generating Social Post:", error);
      setIsLoading(false);
      swal({
        text: error.message || "Something went wrong!",
        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      });
    }
  };

  return (
    <Fragment>
      {/* <PageHeading
        title={"SOCIAL POST AI"}
        description={
          "Social posts go viral by stopping the scroll with quick, authentic storytelling."
        }
        onInfoClick={() => setShowPdfModal(true)}
        infoTooltip="See sample social post"
      /> */}

      <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="What you can do?">
        <ContentPhotoPostAi />
      </SamplePdfModal>

      <div
        style={{
          maxWidth: "872px",
          paddingInline: "12px",
          marginInline: "auto",
        }}
        className="container pb-2"
      >
        <div className="container py-0">
          {/* <div className="CreditDiv mt-3 d-flex flex-column gap-2"> */}
          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
            <div className="">
              {/* <div>
                <button className="credits-button">
                  CREDITS : {creditToLocalString}
                </button>
                <button
                  className="buy-credits-button"
                  onClick={() => navigate("/purchase")}
                >
                  BUY CREDITS
                </button>
                <button
                  onClick={() => navigate("/usage")}
                  className="money-exchange-button"
                >
                  <img src={moneyExchangeIcon} alt="moneyExchangeIcon" />
                </button>
              </div> */}
              <p className="all-page-title all-page-gradient-text text-center my-4">SOCIAL POST AI</p>
              <div className="credits-actions">

                <button className="credits-button">
                  CREDITS : {creditToLocalString}
                </button>

                <button
                  className="buy-credits-button"
                  onClick={() => navigate("/purchase")}
                >
                  BUY CREDITS
                </button>

                <button
                  onClick={() => navigate("/usage")}
                  className="money-exchange-button"
                >
                  <img src={moneyExchangeIcon} alt="usage" />
                </button>

                <button
                  type="button"
                  className="money-exchange-button"
                  onClick={() => {
                    setShowPdfModal(true);
                  }}

                >
                  <img src={sampleIcon} alt="See sample video" />
                </button>

              </div>
              <p
                style={{ fontSize: "8px" }}
                className="text-white mt-2 creditText text-center"
              >
                {credit} Credits (USD {creditCostUSD.toFixed(2)} based on Credits Package 3)
              </p>
            </div>
          </div>
          <p style={{ fontSize: "10px" }} className="text-white text-md-center text-lg-center text-center mb-5 d-flex justify-content-center">This AI will be generated on our server and sent to your email, so you don't have to wait</p>
          <div className="mb-4 d-flex align-items-center justify-content-center">
            <img
              src={"/photoPostAi.png"}
              alt="photoPostAi"
              className="img-fluid responsive-img"
            />
          </div>
          <div className="text-center mb-3">
            <p style={{ color: "white" }}>
              Just add a title, and we'll handle the rest. Perfect for any
              social media platform.
            </p>
          </div>

          <div className="mb-3">
            <label className="text-white mb-2" style={{ fontSize: "14px" }}>
              Title <span className="text-danger">*</span>
            </label>
            <textarea
              type="text"
              className="p-2 px-3 w-100 text-white"
              style={{
                background: "#011C34",
                border: "2px solid #FFF",
                borderRadius: "12px",
                outline: "none",
                height: "100px"
              }}
              value={title}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);

                if (promptTimeoutRef.current) {
                  clearTimeout(promptTimeoutRef.current);
                }

                promptTimeoutRef.current = setTimeout(() => {
                  checkPhotoPostIdeaPrompt(value);
                }, 1500);
              }}
              placeholder="Enter title..."
            />
          </div>

          {checkingPrompt && (
            <div className="d-flex align-items-center mt-2 mb-2">
              <div className="spinner-border text-light spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span className="text-warning" style={{ marginLeft: "8px" }}>Generating suggestion...</span>
            </div>
          )}

          {suggestedIdea && (
            <div
              onClick={() => setTitle(suggestedIdea)}
              style={{
                cursor: "pointer",
                background: "#0b2d4d",
                padding: "12px",
                borderRadius: "10px",
                marginTop: "0px",
                marginBottom: "12px",
                border: "1px solid #fff",
              }}
            >
              <p className="mb-1 text-warning">Suggested Title:</p>
              <p className="mb-0 text-white">{suggestedIdea}</p>
            </div>
          )}
          <div className="d-flex flex-column flex-md-row gap-3 mb-3">
            <div className="flex-fill">
              <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                Background
              </label>
              <select
                className="p-2 px-3 w-100 text-white"
                style={{
                  background: "#011C34",
                  border: "2px solid #FFF",
                  borderRadius: "12px",
                  outline: "none",
                  cursor: "pointer",
                  appearance: "auto",
                }}
                value={backgroundColor}
                onChange={(e) => setBackgroundColor(e.target.value)}
              >
                <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                <option value="random">Random</option>
                {backgroundColorOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {backgroundColor === "custom" && (
                <div className="mt-2 text-center">
                  <input
                    type="color"
                    value={customBgColor}
                    onChange={(e) => setCustomBgColor(e.target.value)}
                    style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                  />
                  <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                    {customBgColor.toUpperCase()}
                  </div>
                </div>
              )}
            </div>
            <div className="flex-fill">
              <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                Text Combination 01
              </label>
              <select
                className="p-2 px-3 w-100 text-white"
                style={{
                  background: "#011C34",
                  border: "2px solid #FFF",
                  borderRadius: "12px",
                  outline: "none",
                  cursor: "pointer",
                  appearance: "auto",
                }}
                value={textColor1}
                onChange={(e) => handleTextColor1Change(e.target.value)}
              >
                <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                {textColorOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {textColor1 === "custom" && (
                <div className="mt-2 text-center">
                  <input
                    type="color"
                    value={customTextColor1}
                    onChange={(e) => setCustomTextColor1(e.target.value)}
                    style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                  />
                  <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                    {customTextColor1.toUpperCase()}
                  </div>
                </div>
              )}
            </div>
            <div className="flex-fill">
              <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                Text Combination 02
              </label>
              <select
                className="p-2 px-3 w-100 text-white"
                style={{
                  background: "#011C34",
                  border: "2px solid #FFF",
                  borderRadius: "12px",
                  outline: "none",
                  cursor: "pointer",
                  appearance: "auto",
                }}
                value={textColor2}
                onChange={(e) => setTextColor2(e.target.value)}
              >
                <option value="custom" style={{ color: '#ffa21f', fontWeight: 'bold' }}>Custom Color</option>
                {textColorOptions
                  .filter((option) => option.value === "random" || option.value === "custom" || option.value !== textColor1)
                  .map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
              </select>
              {textColor2 === "custom" && (
                <div className="mt-2 text-center">
                  <input
                    type="color"
                    value={customTextColor2}
                    onChange={(e) => setCustomTextColor2(e.target.value)}
                    style={{ width: "100%", height: "40px", cursor: "pointer", border: "none", background: "transparent", padding: 0 }}
                  />
                  <div className="text-white mt-1" style={{ fontSize: "12px", fontFamily: "monospace" }}>
                    {customTextColor2.toUpperCase()}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            className="d-flex align-items-center justify-content-center text-center mt-4 mb-4"
          >
            <input
              type="checkbox"
              id="attributionCheckboxInline"
              style={{ marginRight: '8px' }}
              checked={attributionPage}
              onChange={(e) => setAttributionPage(e.target.checked)}
            />
            <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
              The Attribution
            </label>
          </div>

          <AiContentAudit checked={auditChecked} onChange={setAuditChecked} auditCreditCost={84} />

          <div className="d-flex justify-content-center align-items-center mb-5">
            <Button
              sx={{
                padding: "8px 30px",
                marginRight: "10px",
                color: "#000",
                background: "#fff",
                "&:hover": { background: "#fff" },
                "&:disabled": { background: "#fff" },
              }}
              onClick={() => {
                setTitle("");
                const newBg = getRandomBackgroundColor();
                const newT1 = getRandomTextColor();
                const newT2 = getRandomTextColor(newT1);
                setBackgroundColor(newBg);
                setTextColors({ textColor1: newT1, textColor2: newT2 });
                setCustomBgColor("#000000");
                setCustomTextColor1("#ffffff");
                setCustomTextColor2("#ffffff");
                setSuggestedIdea("");
                setGeneratedPost(null);
              }}
              disabled={!title || isLoading}
              variant="contained"
            >
              Clear
            </Button>
            <Button
              sx={{
                padding: "8px 30px",
                "&:disabled": { background: "gray" },
              }}
              onClick={() => {
                handleGenerate();
              }}
              className="generate-button text-white"
              disabled={!title.trim() || isLoading}
              variant="contained"
            >
              {isLoading ? "Processing..." : "Generate"}
            </Button>
          </div>
          <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
            While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
          </div>

          {/* Progress section */}
          {isLoading && (
            <div className="d-flex flex-column align-items-center mt-4 mb-3">
              <div
                className="spinner-border text-light mb-3"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              {jobStatusText && (
                <p className="text-warning text-center mb-2" style={{ fontSize: "14px" }}>
                  {jobStatusText}
                </p>
              )}
              <div style={{
                width: "100%",
                maxWidth: "400px",
                background: "#0b2d4d",
                borderRadius: "10px",
                overflow: "hidden",
                height: "20px",
                border: "1px solid #1a4a7a",
              }}>
                <div style={{
                  width: `${jobProgress}%`,
                  height: "100%",
                  background: "linear-gradient(90deg, #ffa21f, #ff6b00)",
                  borderRadius: "10px",
                  transition: "width 0.5s ease",
                }} />
              </div>
              <p className="text-white mt-1" style={{ fontSize: "12px" }}>
                {jobProgress}%
              </p>
            </div>
          )}

          {/* Interesting facts while generating */}
          {isLoading && <AiFactsDisplay />}

          {generatedPost && (
            <div className="mt-5 d-flex flex-column align-items-center">
              <h4 className="text-white mb-4">Generated Social Post</h4>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "20px",
                  width: "100%",
                  maxWidth: "872px",
                  marginBottom: "24px",
                }}
              >
                {generatedPost.slides?.map((slide, index) => (
                  <img
                    key={index}
                    src={slide}
                    alt={`Slide ${index + 1}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedImage(slide);
                    }}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "scale(1.02)"}
                    onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                  />
                ))}
              </div>

              {generatedPost.summary && (
                <div className="w-100 mb-4">
                  <label className="text-white mb-2" style={{ fontSize: "14px" }}>
                    Viral Summary
                  </label>
                  <textarea
                    readOnly
                    className="p-2 px-3 w-100 text-white"
                    style={{
                      background: "#011C34",
                      border: "2px solid #FFF",
                      borderRadius: "12px",
                      outline: "none",
                      minHeight: "120px",
                    }}
                    value={generatedPost.summary}
                  />
                </div>
              )}

              <Button
                sx={{
                  padding: "8px 30px",
                  color: "#000",
                  background: "#fff",
                  "&:hover": { background: "#fff" },
                }}
                onClick={() => window.open(generatedPost.zipUrl, "_blank")}
                variant="contained"
              >
                Download ZIP
              </Button>
            </div>
          )}

          {/* Lightbox Modal */}
          {selectedImage && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.85)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                cursor: "pointer",
              }}
              onClick={() => setSelectedImage(null)}
            >
              <img
                src={selectedImage}
                alt="Preview"
                style={{
                  maxWidth: "90vw",
                  maxHeight: "90vh",
                  borderRadius: "12px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                }}
                onClick={(e) => e.stopPropagation()}
              />
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  right: "30px",
                  color: "#fff",
                  fontSize: "30px",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedImage(null)}
              >
                ✕
              </div>
            </div>
          )}

        </div>
      </div>
    </Fragment>
  );
};

export default PhotoPostAi;
